import {
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST,
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS,
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const contractsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default contractsReducer;
